import { render } from "./CheckEmail.vue?vue&type=template&id=21e845db&scoped=true"
import script from "./CheckEmail.vue?vue&type=script&lang=js"
export * from "./CheckEmail.vue?vue&type=script&lang=js"

import "./CheckEmail.vue?vue&type=style&index=0&id=21e845db&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e845db"]])

export default __exports__